<template>
  <div>
    <base-modal :show="showModal" @close="handleClose" @save="handleSave">
      <template v-slot:header> {{ title }} </template>
      <template v-slot:main>
        <div class="ml-40">
          <photoshop v-model="color"></photoshop>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
const clone = require("lodash/cloneDeep");
import { Photoshop } from "vue-color";
export default {
  name: "ColorPicker",
  components: { Photoshop },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      color: {},
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleSave() {
      this.$emit("save", this.color.hex);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.color = clone(newValue);
        }
      },
    },
  },
};
</script>
